import { INIT, CHANGE_MODE } from './types';

// eslint-disable-next-line import/prefer-default-export
export const init = () => ({ type: INIT });
export const changeMode = mode => ({ type: CHANGE_MODE, mode });
